import { render, staticRenderFns } from "./postTwitter.vue?vue&type=template&id=fd031c4c"
import script from "./postTwitter.vue?vue&type=script&lang=js"
export * from "./postTwitter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd031c4c')) {
      api.createRecord('fd031c4c', component.options)
    } else {
      api.reload('fd031c4c', component.options)
    }
    module.hot.accept("./postTwitter.vue?vue&type=template&id=fd031c4c", function () {
      api.rerender('fd031c4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/standardTab/renderPost/postTwitter.vue"
export default component.exports